// services/leads-fila.service.ts
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { LeadsFilaRequest, LeadsFilaResponse } from '../interfaces/leads-fila.interface';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root'
})
export class LeadsFilaService extends BaseApiService {

  getLeadsFila(request: LeadsFilaRequest): Observable<LeadsFilaResponse> {
    return this.post<LeadsFilaResponse>('/lead/fila', request).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }
}


